import { Group, Paper, PaperProps, TextProps } from '@mantine/core';
import { ReactNode } from 'react';
import { ClickableSectionTitle } from 'src/UI/page-nav/ClickableSectionTitle';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
  titleProps?: TextProps;
  headerMb?: PaperProps['mb'];
  paperProps?: Omit<PaperProps, 'children' | 'variant'>;
};

export default function CompanySectionLayout({
  title,
  actions,
  children,
  titleProps,
  headerMb = 'md',
  paperProps,
}: Props) {
  return (
    <Paper variant="content" p="xxl" {...paperProps}>
      <Group justify="space-between" align="center" mb={headerMb}>
        <ClickableSectionTitle
          size="displayMd"
          fw={FONT_WEIGHTS.medium}
          c="gray.10"
          {...titleProps}
        >
          {title}
        </ClickableSectionTitle>
        {actions}
      </Group>
      {children}
    </Paper>
  );
}
